import React from 'react';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { SocialProofStats } from '../components/sections/SocialProofStats';
import { TrustStrip } from '../components/sections/TrustStrip';
import { MoneyPageSpotlight } from '../components/sections/MoneyPageSpotlight';
import { HowItWorks } from '../components/sections/HowItWorks';
import { CapabilityGrid } from '../components/sections/CapabilityGrid';
import { TestimonialCarousel } from '../components/sections/TestimonialCarousel';
import { AboutSection } from '../components/sections/AboutSection';
import { ArtworkGuidance } from '../components/sections/ArtworkGuidance';
import { GuaranteeStrip } from '../components/sections/GuaranteeStrip';
import { FinalCTA } from '../components/sections/FinalCTA';
import { FloatingCTA } from '../components/ui/FloatingCTA';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-423">
      <AnnouncementBar data-id="element-424" />
      <Header data-id="element-425" />

      <main data-id="element-426">
        <HeroSection data-id="element-427" />
        <SocialProofStats data-id="element-428" />
        <TrustStrip data-id="element-429" />
        <MoneyPageSpotlight data-id="element-430" />
        <HowItWorks data-id="element-431" />
        <CapabilityGrid data-id="element-432" />
        <TestimonialCarousel data-id="element-433" />
        <AboutSection data-id="element-434" />
        <ArtworkGuidance data-id="element-435" />
        <GuaranteeStrip data-id="element-436" />
        <FinalCTA data-id="element-437" />
      </main>

      <Footer data-id="element-438" />
      <FloatingCTA data-id="element-439" />
    </div>;
}